import validate from "/usr/src/app/node_modules/.bun/nuxt@4.6.2+6887b9758eaf5934/node_modules/nuxt/dist/pages/runtime/validate.js";
import prev_45global from "/usr/src/app/apps/storefront/middleware/prev.global.ts";
import manifest_45route_45rule from "/usr/src/app/node_modules/.bun/nuxt@4.6.2+6887b9758eaf5934/node_modules/nuxt/dist/app/middleware/route-rules.js";
export const globalMiddleware = [
  validate,
  prev_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {
  "i18n-my": () => import("/usr/src/app/apps/storefront/middleware/i18n._my_.ts")
}